<template>
  <div>
    <v-card>
      <v-card-title>
        <span class="headline font-weight-thin">{{ categoryName }}</span>
        <v-btn icon>
          <v-icon small @click="showEditForm = true" data-cy="categoryView__editBtn">fas fa-edit</v-icon></v-btn
        >
      </v-card-title>
      <v-btn
        text
        small
        @click="$router.push({ name: 'adminServiceAreaCategoryList' })"
        data-cy="categoryView__returnToListBtn"
      >
        <v-icon class="mr-1" small>fas fa-arrow-left</v-icon>Return to Category List
      </v-btn>
      <v-container v-if="showEditForm">
        <v-row>
          <v-col sm="6">
            <v-form v-model="valid">
              <v-card-text>
                <v-text-field
                  clearable
                  data-cy="categoryView__categoryName"
                  v-model="serviceAreaCategory.name"
                  :rules="nameRules"
                  label="Name"
                  required
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-btn @click="cancel" outlined>Cancel</v-btn>
                <v-btn @click="save" :disabled="!valid" color="primary" data-cy="categoryView__saveBtn">Save</v-btn>
              </v-card-actions>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
      <v-divider></v-divider>
      <AdminServiceAreaAttributeList></AdminServiceAreaAttributeList>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import AdminServiceAreaAttributeList from "./AdminServiceAreaAttributeList";

export default {
  components: {
    AdminServiceAreaAttributeList,
  },
  computed: {
    ...mapState({
      serviceAreaCategory: state => state.admin.serviceAreaCategory.edit,
      serviceAreaCategoryOriginal: state => state.admin.serviceAreaCategory.record,
    }),
  },
  async created() {
    try {
      await this.fetchCategory(this.id);
      this.categoryName = this.serviceAreaCategory.name;
    } catch (e) {
      console.error(e);
    }
  },
  data() {
    return {
      id: parseInt(this.$route.params.id, 10),
      nameRules: [name => !!name || "Name is required"],
      categoryName: null,
      showEditForm: false,
      valid: true,
    };
  },
  methods: {
    async cancel() {
      this.resetEdit(this.serviceAreaCategoryOriginal);
      this.showEditForm = false;
    },
    async save() {
      try {
        await this.updateCategory(this.serviceAreaCategory);
        this.updateCategorySuccess();
        this.categoryName = this.serviceAreaCategory.name;
      } catch (e) {
        console.error(e);
        this.updateCategoryError();
      }
      await this.fetchCategory(this.id);
      await this.fetchCategoryList();
      this.showEditForm = false;
    },
    ...mapActions({
      fetchCategory: "admin/serviceAreaCategory/fetchRecord",
      fetchCategoryList: "admin/serviceAreaCategory/list",
      updateCategory: "admin/serviceAreaCategory/update",
      resetEdit: "admin/serviceAreaCategory/resetEdit",
    }),
  },
  notifications: {
    updateCategorySuccess: {
      title: "Success!",
      message: "Successfully updated category name.",
      type: "success",
    },
    updateCategoryError: {
      title: "Error!",
      message: "There was an error updating category name.",
      type: "error",
    },
  },
};
</script>
